import React from 'react';
import { CoreGoogleUserTrackingConflict, CoreGoogleUserTrackingConflictType } from '../../../../models/CoreTrackingOperation';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface GoogleUserTrackingOperationsValidationResultProps {
    googleId?: string
    primaryEmail?: string
    conflicts: CoreGoogleUserTrackingConflict[]
}

const GoogleUserTrackingOperationsValidationResult: React.FC<GoogleUserTrackingOperationsValidationResultProps> = (props) => {
        const { t } = useTranslation(['schoolAdministration', 'common']);

    const conflictLookup = new Map<CoreGoogleUserTrackingConflictType, CoreGoogleUserTrackingConflict[]>();
    props.conflicts.forEach((conflict) => {
        const conflicts = conflictLookup.get(conflict.type);
        if (conflicts) {
            conflicts.push(conflict);
        } else {
            conflictLookup.set(conflict.type, [conflict]);
        }
    });
    const getText = (conflictType: CoreGoogleUserTrackingConflictType, googleId?: string, primaryEmail?: string): string => {
        switch (conflictType) {
            case CoreGoogleUserTrackingConflictType.TrackingKey:
                return t('trackingOperations.google.validationResult.connectionExistsFlowSyncGoogle', {ns: 'schoolAdministration', GoogleId: googleId});
            case CoreGoogleUserTrackingConflictType.SourceObjectType:
                return t('trackingOperations.google.validationResult.connectionExistsPersonRole', {ns: 'schoolAdministration'});
            case CoreGoogleUserTrackingConflictType.Identifier:
                return t('trackingOperations.google.validationResult.connectionExistsPersonsGoogle', {ns: 'schoolAdministration', GoogleId: googleId});
            case CoreGoogleUserTrackingConflictType.EmailAddress:
                return t('trackingOperations.google.validationResult.emailAlreadyExists', {ns: 'schoolAdministration', PrimaryEmail: primaryEmail});
            default:
                return t('trackingOperations.google.validationResult.error', {ns: 'schoolAdministration'});
        }
    }

    return <>{Array.from(conflictLookup).sort((a, b) => a[0] - b[0]).map((entry) => (<>
        <p>{getText(entry[0], props.googleId, props.primaryEmail)}</p>
        {showUserLinks(entry[0]) && <ul>
            {entry[1].map((conflict) => (<li key={conflict.trackingId}><Link target="_blank" to={`/user/${conflict.flowSyncId}/trackings`}>{conflict.displayName}</Link></li>))}
        </ul>}
    </>))}
    </>;
}


const showUserLinks = (conflictType: CoreGoogleUserTrackingConflictType): boolean => {
    switch (conflictType) {
        case CoreGoogleUserTrackingConflictType.TrackingKey:
        case CoreGoogleUserTrackingConflictType.SourceObjectType:
            return false;
        case CoreGoogleUserTrackingConflictType.Identifier:
        case CoreGoogleUserTrackingConflictType.EmailAddress:
            return true;
        default:
            return false;
    }
}

export default GoogleUserTrackingOperationsValidationResult;
